import { ViewBookingStatusEnum } from "collins-js-sdk";
import { AlertTriangle } from "lucide-react";
import React from "react";

interface DiaryBookingCardOfflineIndicatorProps {
  unsaved?: boolean;
  bookingId?: string;
  status?: ViewBookingStatusEnum;
}

export const DiaryBookingCardOfflineIndicator =
  React.memo<DiaryBookingCardOfflineIndicatorProps>(
    ({ unsaved, bookingId, status }) => {
      if (!unsaved) {
        return null;
      }

      return (
        <div className="DiarySidebarListItem__detailsOffline">
          <div className="DiarySidebarListItem__detailsOffline__icon">
            <AlertTriangle style={{ color: "var(--accent-color, #1fd4d4)" }} />
          </div>
          {!bookingId && <span>Not Updated</span>}
          {bookingId && (
            <span>
              {status === ViewBookingStatusEnum.Rejected ||
              status === ViewBookingStatusEnum.Deleted
                ? "Deleted "
                : "Modified "}
              - Not Updated
            </span>
          )}
        </div>
      );
    }
  );

DiaryBookingCardOfflineIndicator.displayName =
  "DiaryBookingCardOfflineIndicator";
